var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c(
        "div",
        { staticClass: "tile is-parent", class: { "box  ml-2": _vm.showBox } },
        [
          _c("article", { staticClass: "tile is-child is-parent" }, [
            _vm._m(0),
            _c("div", { staticClass: "is-divider" }),
            _c("div", { staticClass: "tile is-ancestor" }, [
              _c("div", { staticClass: "tile" }, [
                _c("div", { staticClass: "tile is-parent is-half" }, [
                  _c(
                    "article",
                    {
                      staticClass: "tile is-child",
                      class: { disabled: _vm.value.quoteId },
                    },
                    [
                      _c("div", { staticClass: "field" }, [
                        _c(
                          "label",
                          { staticClass: "label is-required-label" },
                          [_vm._v("Registration No. ")]
                        ),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.value.vehicleRegistrationNo,
                                expression: "value.vehicleRegistrationNo",
                              },
                            ],
                            staticClass: "input",
                            class: {
                              "is-danger":
                                _vm.$v.entity.vehicleRegistrationNo.$error,
                            },
                            attrs: { type: "text" },
                            domProps: {
                              value: _vm.value.vehicleRegistrationNo,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.value,
                                  "vehicleRegistrationNo",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm.$v.entity &&
                          !_vm.$v.entity.vehicleRegistrationNo.required
                            ? _c("span", { staticClass: "help is-danger" }, [
                                _vm._v("Registration No. is required"),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [_vm._v("Make")]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.value.vehicleMake,
                                expression: "value.vehicleMake",
                              },
                            ],
                            staticClass: "input",
                            attrs: { type: "text" },
                            domProps: { value: _vm.value.vehicleMake },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.value,
                                  "vehicleMake",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Model"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.value.vehicleModel,
                                expression: "value.vehicleModel",
                              },
                            ],
                            staticClass: "input",
                            attrs: { type: "text" },
                            domProps: { value: _vm.value.vehicleModel },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.value,
                                  "vehicleModel",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [_vm._v("Year")]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.value.vehicleYear,
                                expression: "value.vehicleYear",
                              },
                            ],
                            staticClass: "input",
                            attrs: { type: "number" },
                            domProps: { value: _vm.value.vehicleYear },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.value,
                                  "vehicleYear",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("div", { staticClass: "columns field is-hidden" }, [
                        _vm.isInspectionBooked
                          ? _c("div", { staticClass: "column" }, [
                              _vm._m(1),
                              _c(
                                "div",
                                { staticClass: "field" },
                                [
                                  _c("bulma-checkbox-date", {
                                    attrs: {
                                      date: _vm.value
                                        .arriveForInspectionSyncedDate,
                                    },
                                    model: {
                                      value: _vm.value.isArriveForInspection,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.value,
                                          "isArriveForInspection",
                                          $$v
                                        )
                                      },
                                      expression: "value.isArriveForInspection",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "columns field" }, [
                        _c("div", { staticClass: "column" }, [
                          _c(
                            "div",
                            { staticClass: "field" },
                            [
                              _c("bulma-checkbox-date", {
                                attrs: {
                                  label: "Is Towed?",
                                  date: _vm.value.towedDate,
                                },
                                model: {
                                  value: _vm.value.isTowed,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.value, "isTowed", $$v)
                                  },
                                  expression: "value.isTowed",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns mb-0" }, [
      _c("div", { staticClass: "column is-flex is-align-items-center" }, [
        _c("i", { staticClass: "icon mdi mdi-car mdi-24px" }),
        _c("p", { staticClass: "modal-card-title pl-1" }, [_vm._v("Vehicle")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [
        _vm._v("Is Arrive For Inspection?"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }